export default "__VITE_ASSET__CWNDtkj0__"